/** Labels for agent_site_settings.custom_domain_status (backend SSOT). */

export const WHITE_LABEL_DOMAIN_STATUSES = ["none", "pending", "verified", "rejected", "disabled"];

export function whiteLabelDomainStatusLabel(status) {
  const s = String(status || "none").trim().toLowerCase();
  switch (s) {
    case "pending":
      return "ממתין לאישור";
    case "verified":
      return "מאומת";
    case "rejected":
      return "נדחה";
    case "disabled":
      return "מושבת";
    case "none":
    default:
      return "לא הוגדר";
  }
}

export function whiteLabelDomainStatusColor(status) {
  const s = String(status || "none").trim().toLowerCase();
  switch (s) {
    case "pending":
      return "orange";
    case "verified":
      return "green";
    case "rejected":
      return "red";
    case "disabled":
      return "default";
    default:
      return "default";
  }
}

export function canAgentSubmitWhiteLabelDomain(status) {
  const s = String(status || "none").trim().toLowerCase();
  return s === "none" || s === "rejected" || s === "disabled";
}

export function canAgentDeleteWhiteLabelDomainRequest(status) {
  const s = String(status || "none").trim().toLowerCase();
  return s === "pending" || s === "rejected";
}
